var _style, _rect, _g, _path, _path2, _rect2, _rect3, _defs, _g2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{opacity:0.2;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{opacity:0.12;}\n\t.st4{fill:#103F91;}\n\t.st5{fill:#41A5EE;}\n\t.st6{fill:#185ABD;}\n\t.st7{fill:#2B7CD3;}\n\t.st8{clip-path:url(#SVGID_2_);}\n\t.st9{opacity:0.48;}\n\t.st10{opacity:0.24;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 512,
    height: 512
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Word"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_142"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ambient-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152.3,48.3h311.2c10.8,0,19.6,8.8,19.6,19.6v376.2c0,10.8-8.8,19.6-19.6,19.6H152.3 c-10.8,0-19.6-8.8-19.6-19.6V67.9C132.7,56.9,141.5,48.3,152.3,48.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152.3,48.3h311.2c10.8,0,19.6,8.8,19.6,19.6v376.2c0,10.8-8.8,19.6-19.6,19.6H152.3 c-10.8,0-19.6-8.8-19.6-19.6V67.9C132.7,56.9,141.5,48.3,152.3,48.3z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M152.1,463.2h311.4c10.6,0.2,19.4-8.5,19.6-19.1l0,0v-84.4H132.7v84.4c0,10.6,8.6,19.1,19.1,19.1H152.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M463.5,48.5H152.1c-10.6-0.2-19.3,8.3-19.3,18.9l0,0c0,0.2,0,0.4,0,0.5v84.2h350.3V67.5 c0-10.6-8.6-19.1-19.1-19.1L463.5,48.5L463.5,48.5z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 132.7,
    y: 255.8,
    className: "st6",
    width: 350.5,
    height: 103.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 132.7,
    y: 152,
    className: "st7",
    width: 350.5,
    height: 103.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M152.3,48.3h311.2c10.8,0,19.6,8.8,19.6,19.6v376.2c0,10.8-8.8,19.6-19.6,19.6H152.3 c-10.8,0-19.6-8.8-19.6-19.6V67.9C132.7,56.9,141.5,48.3,152.3,48.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ambient-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.5,139h194.4c10.8,0,19.6,8.8,19.6,19.6V353c0,10.8-8.8,19.6-19.6,19.6H48.5 c-10.8,0-19.6-8.8-19.6-19.6V158.6C28.8,147.8,37.7,139,48.5,139z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M48.5,139h194.4c10.8,0,19.6,8.8,19.6,19.6V353c0,10.8-8.8,19.6-19.6,19.6H48.5 c-10.8,0-19.6-8.8-19.6-19.6V158.6C28.8,147.8,37.7,139,48.5,139z"
  }))))))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M48.5,139h194.4c10.8,0,19.6,8.8,19.6,19.6V353c0,10.8-8.8,19.6-19.6,19.6H48.5c-10.8,0-19.6-8.8-19.6-19.6 V158.6C28.8,147.8,37.7,139,48.5,139z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M107,288.2v7.9l0,0v-7.6c0.4-2.5,0.9-5,1.6-7.6l20.3-88.4h26.5l23.2,86.4c1.3,5.4,2.3,10.8,2.7,16.4l0,0 c0.4-5.4,1.1-10.6,2.3-15.8l16.7-87.5h24.3L195,318.8h-27.9l-20.3-83.9c0-2.5-1.1-5.6-1.8-9.4c-0.7-3.8-1.1-6.7-1.4-8.5l0,0 c0,3.1-0.4,6.3-1.4,9.2c-0.9,2.9-1.4,5.9-1.6,9l-18.2,84.2H92.6L62.7,192.5h24.5l18.4,88.7C106.2,283.5,106.6,285.9,107,288.2z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftWord);
export default __webpack_public_path__ + "static/media/microsoft-word.923367922b223e1fd1a4b47769e49cb5.svg";
export { ForwardRef as ReactComponent };